import React, { useState, useEffect } from "react";
import Menu from "./Menu";
import axios from "axios";
import { useNavigate } from "react-router-dom";

// Custom icons component to replace FontAwesome
const Icon = ({ name }) => {
  const icons = {
    faTable: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
        <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm15 2h-4v3h4V4zm0 4h-4v3h4V8zm0 4h-4v3h3a1 1 0 0 0 1-1v-2zm-5 3v-3H6v3h4zm-5 0v-3H1v2a1 1 0 0 0 1 1h3zm-4-4h4V8H1v3zm0-4h4V4H1v3zm5-3v3h4V4H6zm4 4H6v3h4V8z"/>
      </svg>
    ),
    faPaperPlane: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
        <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083l6-15zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178z"/>
      </svg>
    ),
    faChevronLeft: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
        <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
      </svg>
    ),
    faChevronRight: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
        <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
      </svg>
    ),
    faTimes: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
      </svg>
    ),
    faPlus: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
      </svg>
    ),
    faSpinner: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="spin" viewBox="0 0 16 16">
        <path d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
      </svg>
    )
  };
  
  return icons[name] || null;
};

// CSS Styles to replace AdminLTE
const styles = {
  wrapper: {
    display: 'flex',
    minHeight: '100vh',
    width: '100%',
    maxWidth: '100%',
    backgroundColor: 'var(--bg)',
    position: 'relative'
  },
  contentWrapper: {
    flexGrow: 1,
    padding: '20px',
    // marginLeft: '250px',
    backgroundColor: 'var(--bg)',
    transition: 'margin-left 0.3s ease-in-out'
  },
  contentHeader: {
    padding: '15px 0'
  },
  containerFluid: {
    width: '100%',
    paddingRight: '15px',
    paddingLeft: '15px',
    marginRight: 'auto',
    marginLeft: 'auto'
  },
  row: {
    display: 'flex',
    flexWrap: 'wrap',
    marginRight: '-15px',
    marginLeft: '-15px'
  },
  col12: {
    flex: '0 0 100%',
    maxWidth: '100%',
    position: 'relative',
    width: '100%',
    paddingRight: '15px',
    paddingLeft: '15px'
  },
  col6: {
    flex: '0 0 50%',
    maxWidth: '50%',
    position: 'relative',
    width: '100%',
    paddingRight: '15px',
    paddingLeft: '15px'
  },
  mb2: {
    marginBottom: '0.5rem'
  },
  card: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    wordWrap: 'break-word',
    backgroundColor: 'var(--surface)',
    backgroundClip: 'border-box',
    border: '1px solid var(--border)',
    borderRadius: '0.25rem',
    marginBottom: '1rem',
    boxShadow: '0 0 1px rgba(0,0,0,.125), 0 1px 3px rgba(0,0,0,.2)'
  },
  cardHeader: {
    padding: '0.75rem 1.25rem',
    marginBottom: 0,
    backgroundColor: 'var(--surface2)',
    borderBottom: '1px solid var(--border)'
  },
  cardTitle: {
    float: 'left',
    fontSize: '1.1rem',
    fontWeight: 400,
    margin: 0
  },
  cardBody: {
    flex: '1 1 auto',
    padding: '1.25rem'
  },
  cardFooter: {
    padding: '0.75rem 1.25rem',
    backgroundColor: 'var(--surface2)',
    borderTop: '1px solid var(--border)'
  },
  table: {
    width: '100%',
    marginBottom: '1rem',
    color: 'var(--text)',
    borderCollapse: 'collapse',
  },
  tableBordered: {
    border: '1px solid var(--border)',
  },
  tableHover: {
    cursor: 'pointer'
  },
  th: {
    padding: '0.75rem',
    verticalAlign: 'top',
    borderTop: '1px solid var(--border)',
    borderBottom: '2px solid var(--border)',
    backgroundColor: 'var(--surface2)',
  },
  td: {
    padding: '0.75rem',
    verticalAlign: 'top',
    borderTop: '1px solid var(--border)'
  },
  textCenter: {
    textAlign: 'center'
  },
  badge: {
    display: 'inline-block',
    padding: '0.25em 0.4em',
    fontSize: '75%',
    fontWeight: 700,
    lineHeight: 1,
    textAlign: 'center',
    whiteSpace: 'nowrap',
    verticalAlign: 'baseline',
    borderRadius: '0.25rem'
  },
  badgeSuccess: {
    color: 'var(--text-muted)',
    backgroundColor: 'var(--success)',
  },
  badgeDanger: {
    color: 'var(--text-muted)',
    backgroundColor: 'var(--danger)',
  },
  btn: {
    display: 'inline-block',
    fontWeight: 400,
    textAlign: 'center',
    verticalAlign: 'middle',
    userSelect: 'none',
    border: '1px solid var(--border)',
    padding: '0.375rem 0.75rem',
    fontSize: '1rem',
    lineHeight: 1.5,
    borderRadius: '0.25rem',
    transition: 'color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out',
    cursor: 'pointer'
  },
  btnSm: {
    padding: '0.25rem 0.5rem',
    fontSize: '0.875rem',
    lineHeight: 1.5,
    borderRadius: '0.2rem'
  },
  btnGroup: {
    position: 'relative',
    display: 'inline-flex',
    verticalAlign: 'middle'
  },
  btnInfo: {
    color: 'var(--text-muted)',
    backgroundColor: 'var(--info)',
    borderColor: 'var(--info)',
  },
  btnPrimary: {
    color: 'var(--text-muted)',
    backgroundColor: 'var(--info)',
    borderColor: 'var(--info)',
  },
  btnSuccess: {
    color: 'var(--text-muted)',
    backgroundColor: 'var(--success)',
    borderColor: 'var(--success)',
  },
  btnDefault: {
    color: 'var(--text)',
    backgroundColor: 'var(--surface2)',
    borderColor: 'var(--border)',
  },
  btnDanger: {
    color: 'var(--text-muted)',
    backgroundColor: 'var(--danger)',
    borderColor: 'var(--danger)',
  },
  ml1: {
    marginLeft: '0.25rem'
  },
  ml2: {
    marginLeft: '0.5rem'
  },
  mr1: {
    marginRight: '0.25rem'
  },
  mr2: {
    marginRight: '0.5rem'
  },
  mt1: {
    marginTop: '0.25rem'
  },
  mt2: {
    marginTop: '0.5rem'
  },
  p4: {
    padding: '1.5rem'
  },
  formControl: {
    display: 'block',
    width: '100%',
    height: 'calc(1.5em + 0.75rem + 2px)',
    padding: '0.375rem 0.75rem',
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: 1.5,
    color: 'var(--text-muted)',
    backgroundColor: 'var(--surface)',
    backgroundClip: 'padding-box',
    border: '1px solid var(--border)',
    borderRadius: '0.25rem',
    transition: 'border-color .15s ease-in-out,box-shadow .15s ease-in-out'
  },
  formControlSm: {
    height: 'calc(1.5em + 0.5rem + 2px)',
    padding: '0.25rem 0.5rem',
    fontSize: '0.875rem',
    lineHeight: 1.5,
    borderRadius: '0.2rem'
  },
  formGroup: {
    marginBottom: '1rem'
  },
  dFlex: {
    display: 'flex'
  },
  justifyContentEnd: {
    justifyContent: 'flex-end'
  },
  alignItemsCenter: {
    alignItems: 'center'
  },
  flex1: {
    flex: 1
  },
  pagination: {
    display: 'flex',
    paddingLeft: 0,
    listStyle: 'none',
    borderRadius: '0.25rem',
    margin: 0
  },
  pageItem: {
    margin: '0 2px'
  },
  pageLink: {
    position: 'relative',
    display: 'block',
    padding: '0.5rem 0.75rem',
    marginLeft: '-1px',
    lineHeight: 1.25,
    color: 'var(--text)',
    backgroundColor: 'var(--surface)',
    border: '1px solid var(--border)',
    cursor: 'pointer'
  },
  disabled: {
    color: 'var(--text-muted)',
    pointerEvents: 'none',
    cursor: 'auto',
    backgroundColor: 'var(--surface)',
    borderColor: 'var(--border)',
    opacity: 0.65
  },
  active: {
    zIndex: 1,
    color: 'var(--text-muted)',
    backgroundColor: 'var(--info)',
    borderColor: 'var(--info)',
  },
  floatRight: {
    float: 'right'
  },
  mainFooter: {
    backgroundColor: 'var(--surface)',
    borderTop: '1px solid var(--border)',
    color: 'var(--text-muted)',
    padding: '1rem',
    position: 'relative',
    bottom: 0,
    width: 'calc(100% - 250px)',
    marginLeft: '250px'
  },
  modal: {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 1050,
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    outline: 0,
    display: 'block',
    backgroundColor: 'var(--info)',
  },
  modalDialog: {
    position: 'relative',
    width: 'auto',
    margin: '0.5rem',
    pointerEvents: 'none',
    maxWidth: '500px',
    margin: '1.75rem auto'
  },
  modalContent: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    pointerEvents: 'auto',
    backgroundColor: 'var(--surface)',
    backgroundClip: 'padding-box',
    border: '1px solid var(--border)',
    borderRadius: '0.3rem',
    outline: 0
  },
  modalHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    padding: '1rem',
    borderBottom: '1px solid var(--border)',
    borderTopLeftRadius: 'calc(0.3rem - 1px)',
    borderTopRightRadius: 'calc(0.3rem - 1px)'
  },
  modalHeaderPrimary: {
    backgroundColor: 'var(--info)',
    color: 'var(--text-muted)',
  },
  modalTitle: {
    marginBottom: 0,
    lineHeight: 1.5,
    fontSize: '1.25rem'
  },
  modalBody: {
    position: 'relative',
    flex: '1 1 auto',
    padding: '1rem'
  },
  close: {
    float: 'right',
    fontSize: '1.5rem',
    fontWeight: 700,
    lineHeight: 1,
    color: 'var(--text-muted)',
    textShadow: '0 1px 0 #fff',
    opacity: '.5',
    padding: 0,
    backgroundColor: 'transparent',
    border: 0,
    appearance: 'none'
  },
  closeInModal: {
    color: 'var(--text-muted)',
    textShadow: 'none'
  },
  alert: {
    position: 'relative',
    padding: '0.75rem 1.25rem',
    marginBottom: '1rem',
    border: '1px solid transparent',
    borderRadius: '0.25rem'
  },
  alertDanger: {
    color: 'var(--danger)',
    backgroundColor: 'var(--danger)',
    borderColor: 'var(--danger)',
  },
  textDanger: {
    color: 'var(--danger)',
  },
  spinAnimation: {
    '@keyframes spin': {
      from: { transform: 'rotate(0deg)' },
      to: { transform: 'rotate(360deg)' }
    },
    animation: 'spin 1s linear infinite'
  }
};

// Custom Dialog Box Component


const ConnectedDevicesPage = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  
  const token = getCookie("token");
  const userid = getCookie("userid");

  
  // API data state
  const [devices, setDevices] = useState([]);
  const [fetchingDevices, setFetchingDevices] = useState(true);
  const [deviceError, setDeviceError] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage] = useState(5);

  // Authorization token for API calls
  
  // Fetch Disconnected Devices from API
  const fetchConnectedDevices = async (showLoader = false) => {
    if (showLoader) {
      setFetchingDevices(true);
      setDeviceError(null);
    }
    
    try {
      const response = await axios.get(
        'https://api.dqr-display-tms.eventum.co.in/api/Dashboard/DisconnectedList',
        {
          headers: {
            'accept': 'text/plain',
            'UserId': userid,
            'X-Authorization': token
          }
        }
      );
      
      if (response.data && response.data.isresponse) {
        const deviceList = response.data.list || [];
        setDevices(deviceList);
        setTotalPages(Math.ceil(deviceList.length / itemsPerPage));
        setDeviceError(null);
      } else {
        setDeviceError(response.data?.errormsg || "Failed to fetch Disconnected Devices");
        setDevices([]);
      }
    } catch (err) {
      console.error("Error fetching Disconnected Devices:", err);
      setDeviceError(err.message || "An error occurred while fetching devices");
      setDevices([]);
    } finally {
      if (showLoader) {
        setFetchingDevices(false);
      }
    }
  };



  // Handle pagination
  const handlePrevPage = () => {
    setCurrentPage(prev => Math.max(prev - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage(prev => Math.min(prev + 1, totalPages));
  };

  // Calculate current page items
  const getCurrentItems = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return devices.slice(startIndex, endIndex);
  };


  // Fetch devices on component mount
  useEffect(() => {
    fetchConnectedDevices(true);
    const interval = setInterval(() => {
      fetchConnectedDevices(false);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <Menu />

      {/* Content Wrapper */}
      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <section style={styles.contentHeader}>
          <div style={styles.containerFluid}>
            <div style={{...styles.row, ...styles.mb2}}>
              <div style={styles.col6}>
                <h1>Disconnected Devices</h1>
              </div>
            </div>
          </div>
        </section>

        {/* Main content */}
        <section style={{padding: '20px 0'}}>
          <div style={styles.containerFluid}>
            <div style={styles.row}>
              <div style={styles.col12}>
                <div style={styles.card}>
                  <div style={styles.cardHeader}>
                    <h3 style={styles.cardTitle}>
                      <span style={styles.mr2}><Icon name="faTable" /></span>
                      Disconnected Devices List
                    </h3>
                  </div>
                  {/* Card Body */}
                  <div style={styles.cardBody}>
                    {fetchingDevices ? (
                      <div style={{...styles.textCenter, ...styles.p4}}>
                        <span style={styles.spinAnimation}><Icon name="faSpinner" /></span>
                        <p style={styles.mt2}>Loading devices...</p>
                      </div>
                    ) : (
                      <div style={{overflowX: 'auto'}}>
                        <table style={{...styles.table, ...styles.tableBordered, ...styles.tableHover}}>
                          <thead>
                            <tr style={{backgroundColor: 'var(--surface2)'}}>
                              <th style={styles.th}>Userid</th>
                              <th style={styles.th}>Merchantid</th>
                              <th style={styles.th}>Storeid</th>
                              <th style={styles.th}>Posname</th>
                              <th style={styles.th}>Key</th>
                              <th style={styles.th}>Active</th>
                            </tr>
                          </thead>
                          <tbody>
                            {deviceError ? (
                              <tr>
                                <td colSpan="6" style={{...styles.textCenter, color: 'var(--danger)', padding: '20px'}}>
                                  {deviceError}
                                </td>
                              </tr>
                            ) : getCurrentItems().length > 0 ? (
                              getCurrentItems().map((device, index) => (
                                <tr key={index}>
                                  <td style={styles.td}>{device.id}</td>
                                  <td style={styles.td}>{device.merchantid}</td>
                                  <td style={styles.td}>{device.storeid}</td>
                                  <td style={styles.td}>{device.posname}</td>
                                  <td style={styles.td}>{device.key}</td>
                                  <td style={styles.td}>
                                    <span style={{
                                      ...styles.badge, 
                                      ...(device.active === "True" ? styles.badgeSuccess : styles.badgeDanger)
                                    }}>
                                      {device.active}
                                    </span>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="6" style={{...styles.textCenter, padding: '20px'}}>
                                  No Disconnected Devices found.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                  {/* Card Footer */}
                  <div style={styles.cardFooter}>
                    <ul style={{...styles.pagination, ...styles.floatRight}}>
                      <li style={{
                        ...styles.pageItem, 
                        ...(currentPage === 1 ? styles.disabled : {})
                      }}>
                        <button 
                          style={styles.pageLink} 
                          onClick={handlePrevPage} 
                          disabled={currentPage === 1}
                        >
                          <Icon name="faChevronLeft" />
                        </button>
                      </li>
                      <li style={{...styles.pageItem, ...styles.active}}>
                        <span style={{...styles.pageLink, ...styles.active}}>
                          {currentPage} of {totalPages}
                        </span>
                      </li>
                      <li style={{
                        ...styles.pageItem, 
                        ...(currentPage === totalPages ? styles.disabled : {})
                      }}>
                        <button 
                          style={styles.pageLink} 
                          onClick={handleNextPage} 
                          disabled={currentPage === totalPages}
                        >
                          <Icon name="faChevronRight" />
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

    </div>
  );
};

export default ConnectedDevicesPage;
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}